import type { JSX } from 'react'
import type { ITabProps } from '../Tab'

import { TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { Tab } from '../Tab'
import { TabBackground, TabPaddings } from '../Tab.h'

export interface ITabWithGradientBackgroundProps extends ITabProps {}

export const TabWithGradientBackground = ({
  title = '',
  selected,
  paddings = TabPaddings.SIZE_30,
  color = TextBoxColors.TEXT_ICON_PRIMARY,
  colorHovered = TextBoxColors.SURFACE_LIGHT_2,
  colorPressed = TextBoxColors.BASE_MAIN_PRESSED,
  colorSelected = TextBoxColors.TEXT_ICON_PRIMARY,
  colorSelectedHovered = TextBoxColors.TEXT_ICON_PRIMARY,
  colorSelectedPressed = TextBoxColors.TEXT_ICON_PRIMARY,
  background = TabBackground.COLOR_TRANSPARENT,
  backgroundHovered = TabBackground.COLOR_TRANSPARENT,
  backgroundPressed = TabBackground.COLOR_TRANSPARENT,
  backgroundDisabled = TabBackground.COLOR_TRANSPARENT,
  backgroundSelected = TabBackground.COLOR_TRANSPARENT,
  backgroundSelectedHovered = TabBackground.ACCENT_SECONDARY,
  backgroundSelectedPressed = TabBackground.ACCENT_PRIMARY_PRESSED,
  backgroundSelectedDisabled = TabBackground.COLOR_TRANSPARENT,
  gradientSelected = TabBackground.BUTTON_ACCENT_PRIMARY_GRADIENT,
  font = TextBoxTypes.Button2,
  ...rest
}: ITabWithGradientBackgroundProps): JSX.Element => (
  <Tab
    title={title}
    selected={selected}
    paddings={paddings}
    color={color}
    colorHovered={colorHovered}
    colorPressed={colorPressed}
    colorSelected={colorSelected}
    colorSelectedHovered={colorSelectedHovered}
    colorSelectedPressed={colorSelectedPressed}
    background={background}
    backgroundHovered={backgroundHovered}
    backgroundPressed={backgroundPressed}
    backgroundDisabled={backgroundDisabled}
    backgroundSelected={backgroundSelected}
    backgroundSelectedHovered={backgroundSelectedHovered}
    backgroundSelectedPressed={backgroundSelectedPressed}
    backgroundSelectedDisabled={backgroundSelectedDisabled}
    font={font}
    gradientSelected={gradientSelected}
    {...rest}
  />
)
